import React, { useState, useEffect, useContext } from "react";
import { Layout, Menu, Icon, Row, Col } from "antd";

import Colors from "../../theme/colors";

// Styles
import { Logo } from "./styles";

import { routes } from "../../router/routes";

import { AuthContext } from "../../App";

import { useTranslation  } from 'react-i18next'


// Layout
const { Sider } = Layout;

const SiderMenu = ({ Router, Link }) => {
  const { dispatch } = useContext(AuthContext);
  const [selectedKey, setSelectedKey] = useState("1");

  const { t } = useTranslation();

  useEffect(() => {
    if (window.location.pathname) {
console.log("alain va");
console.log("alainnn",  window.location.pathname);
console.log("routes", routes);
      let new_route = routes.find(route => route.pathlargo === window.location.pathname);
      if (new_route && new_route.key){
console.log("setselectedkey ", new_route.key); 
setSelectedKey(new_route.key);
}
    }
  }, [window.location.pathname]);

  const logout = e => {
    e.preventDefault();
    dispatch({ type: "LOGOUT" });
  };
  return (
    <Sider width={140}>
      <Logo >
        BikiTT
      </Logo>
      <Menu
        theme="dark"
        selectedKeys={[selectedKey]}
        // defaultOpenKeys={["sub2"]}
        mode="inline"
      >
        {routes.map(
          route =>
            route.key && (
              <div
                style={{
                  width: "100%",
                  paddingBottom: "10px",
                  backgroundColor: selectedKey === route.key && Colors.primary
                }}
                key={route.key}
              >
                <Link to={route.path}>
                  <Row type="flex" justify="center" align="middle" style={{ height: "80px" }}>
                    <Col
                      span={24}
                      style={{ textAlign: "center", color: selectedKey === route.key ? "white" : "rgba(255, 255, 255, 0.65)" }}
                    >
                      <Icon type={route.icon} style={{ fontSize: "20px" }} />
                    </Col>
                    <Col
                      span={24}
                      style={{ textAlign: "center", color: selectedKey === route.key ? "white" : "rgba(255, 255, 255, 0.65)" }}
                    >
                      <span>{t('menu.'+route.text)}</span>
                    </Col>
                  </Row>
                </Link>
              </div>
            )
        )}

        <div
          style={{
            width: "100%",
            paddingBottom: "10px",
            bottom: 0,
            position: "absolute",
            cursor: "pointer"
          }}
          onClick={e => logout(e)}
        >
          <Row type="flex" justify="center" align="middle" style={{ height: "80px" }}>
            <Col span={24} style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.65)" }}>
              <Icon type="logout" style={{ fontSize: "20px" }} />
            </Col>
            <Col span={24} style={{ textAlign: "center", color: "rgba(255, 255, 255, 0.65)" }}>
              <span>{t('menu.logout')}</span>
            </Col>
          </Row>
        </div>
      </Menu>
    </Sider>
  );
};

export default SiderMenu;
